import ChooseDateSvg from "./image_choose_date.svg";
import ProgressEmptySvg from "./progress-empty-state.svg";
import HighlightEmptyIcon from "./undraw_bookmarks_re_mq1u.svg";

const opensSansFonts = {
	"opensans-bold": require("./fonts/opensans/opensans-bold.ttf"),
	"opensans-bolditalic": require("./fonts/opensans/opensans-bolditalic.ttf"),
	"opensans-extrabold": require("./fonts/opensans/opensans-extrabold.ttf"),
	"opensans-extrabolditalic": require("./fonts/opensans/opensans-extrabolditalic.ttf"),
	"opensans-italic": require("./fonts/opensans/opensans-italic.ttf"),
	"opensans-light": require("./fonts/opensans/opensans-light.ttf"),
	"opensans-lightitalic": require("./fonts/opensans/opensans-lightitalic.ttf"),
	"opensans-regular": require("./fonts/opensans/opensans-regular.ttf"),
	"opensans-semibold": require("./fonts/opensans/opensans-semibold.ttf"),
	"opensans-semibolditalic": require("./fonts/opensans/opensans-semibolditalic.ttf"),
};
const greetStandardFonts = {
	"greetstandard-bold": require("./fonts/greetstandard/greetstandard-bold.ttf"),
	"greetstandard-regular": require("./fonts/greetstandard/greetstandard-regular.ttf"),
	"greetstandard-semibold": require("./fonts/greetstandard/greetstandard-semibold.ttf"),
	"greetstandard-semibolditalic": require("./fonts/greetstandard/greetstandard-semibolditalic.ttf"),
	"greetstandard-bolditalic": require("./fonts/greetstandard/greetstandard-bolditalic.ttf"),
	"greetstandard-regularitalic": require("./fonts/greetstandard/greetstandard-regularitalic.ttf"),
};

const beausiteFonts = {
	"beausite-regular": require("./fonts/beausite/beausite-regular.ttf"),
	"beausite-bold": require("./fonts/beausite/beausite-bold.ttf"),
	"beausite-bolditalic": require("./fonts/beausite/beausite-bolditalic.ttf"),
	"beausite-semibold": require("./fonts/beausite/beausite-semibold.ttf"),
	"beausite-semibolditalic": require("./fonts/beausite/beausite-semibolditalic.ttf"),
};

const sourceSansProFonts = {
	"sourcesanspro-regular": require("./fonts/sourcesanspro/regular.otf"),
	"sourcesanspro-bold": require("./fonts/sourcesanspro/bold.otf"),
	"sourcesanspro-bolditalic": require("./fonts/sourcesanspro/bolditalic.otf"),
	"sourcesanspro-semibold": require("./fonts/sourcesanspro/semibold.otf"),
	"sourcesanspro-semibolditalic": require("./fonts/sourcesanspro/semibolditalic.otf"),
};

const calibriFonts = {
	"calibri-regular": require("./fonts/calibri/calibri-regular.ttf"),
	"calibri-bold": require("./fonts/calibri/calibri-bold.ttf"),
	"calibri-bolditalic": require("./fonts/calibri/calibri-bolditalic.ttf"),
	"calibri-semibold": require("./fonts/calibri/calibri-semibold.ttf"),
	"calibri-semibolditalic": require("./fonts/calibri/calibri-semibolditalic.ttf"),
	"calibri-italic": require("./fonts/calibri/calibri-italic.ttf"),
};

const customFonts = {
	memorangicons: require("./fonts/memorangicons.ttf"),
	...beausiteFonts,
	...opensSansFonts,
	...greetStandardFonts,
	...sourceSansProFonts,
	...calibriFonts,
};

export { customFonts, HighlightEmptyIcon, ProgressEmptySvg, ChooseDateSvg };
